// extracted by mini-css-extract-plugin
export default {"content":"Zq2oo"};